export default __webpack_public_path__ + "static/media/285.3d6eb3a9.jpg";